import { useState } from 'react';
import { Button, Modal, inputCls } from './ui';

// T137 — saved-view chips + a "Save current view" dialog + a default (★) toggle.
// Pure presentation: the parent owns the list (localStorage via util/savedViews)
// and the apply/save/delete/default handlers.
export default function SavedViewsBar({
  views,
  activeViewId,
  hasActiveFilters,
  onApply,
  onSave,
  onDelete,
  onSetDefault,
}) {
  const [naming, setNaming] = useState(false);
  const [name, setName] = useState('');

  if (views.length === 0 && !hasActiveFilters) return null;

  const submit = () => {
    onSave(name.trim());
    setNaming(false);
    setName('');
  };

  return (
    <div className="mt-3 flex flex-wrap items-center gap-2">
      {views.map((v) => (
        <span key={v.id} className="inline-flex items-center">
          <button
            type="button"
            onClick={() => onApply(v)}
            aria-pressed={v.id === activeViewId}
            className={
              'rounded-full border px-2.5 py-0.5 text-xs transition ' +
              (v.id === activeViewId
                ? 'border-brand-500 bg-brand-600/20 text-brand-400'
                : 'border-slate-700 text-slate-400 hover:border-brand-600 hover:text-brand-400')
            }
          >
            {v.isDefault && <span aria-hidden="true">★ </span>}
            {v.name}
          </button>
          <button
            type="button"
            onClick={() => onSetDefault(v.isDefault ? null : v.id)}
            title={v.isDefault ? 'Stop opening this by default' : 'Make default'}
            aria-label={
              v.isDefault
                ? `Stop opening "${v.name}" by default`
                : `Make "${v.name}" the default view`
            }
            className="ml-1 text-xs text-slate-500 hover:text-amber-300"
          >
            {v.isDefault ? '★' : '☆'}
          </button>
          <button
            type="button"
            onClick={() => onDelete(v.id)}
            aria-label={`Delete view ${v.name}`}
            className="ml-0.5 text-xs text-slate-500 hover:text-red-400"
          >
            ✕
          </button>
        </span>
      ))}

      <Button size="sm" variant="secondary" disabled={!hasActiveFilters} onClick={() => setNaming(true)}>
        Save current view
      </Button>

      {naming && (
        <Modal
          open
          onClose={() => setNaming(false)}
          size="sm"
          title="Save this view"
          footer={
            <>
              <Button variant="primary" size="sm" disabled={!name.trim()} onClick={submit}>
                Save
              </Button>
              <Button variant="ghost" size="sm" onClick={() => setNaming(false)}>
                Cancel
              </Button>
            </>
          }
        >
          <div className="p-4">
            <input
              autoFocus
              className={inputCls}
              value={name}
              onChange={(e) => setName(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === 'Enter' && name.trim()) submit();
              }}
              placeholder="e.g. DK remote ≥60"
              aria-label="View name"
            />
            <p className="mt-2 text-xs text-slate-500">
              Saves the current search + filters. Re-using a name overwrites it.
            </p>
          </div>
        </Modal>
      )}
    </div>
  );
}
